import Layout from "../Layout";
import Phone from "../../assets/icons/Phone.svg";
import Email from "../../assets/icons/Email.svg";
import "./contact.scss";
const Pc = () => {
  return (
    <Layout>
      <div className="container min-vh-100 mt-32">
        <div className="mentions">
          <h1>Politique de confidentialité</h1>

         
        </div>
      </div>
    </Layout>
  );
};
export default Pc;
